module.exports = __webpack_public_path__ + "img/logo.467f0b81.png";